import React, { useState, useEffect, useContext } from "react";
import "./product.css"
import { useNavigate } from "react-router-dom";
import { Context } from "../../app";
import _ from "lodash";

import Image from "../Image/image";


function Product(props) {
    
    const [expanded, setExpanded] = useState(false)
    
    const shop = useContext(Context)

    let navigate = useNavigate()

    // console.log(props.info)
    // console.log(shop.cart?.filter((item)=>item.id===props.product._id))
    // console.log("name", props.name, shop.cart?.filter((item)=>item.name===props.name&&_.isEqual(props.details,item.details)).length)

    return(
        <div onClick={()=>navigate(props.id)} className="product">
            <div className="product-details">
                <Image 
                    src={`products/${props.img}`}
                    width={"100%"}
                />
                {/* <img src={`products/${props.img}`} alt="" /> */}
                <p>{props.name}</p>
                {
                    props.color?
                    <div className="colors">
                        {
                            props.colors.map((prodColor)=>{
                                return(
                                    <div className="shop-color"><div style={{background:prodColor.color}} className="color"></div></div>
                                )
                            })
                        }
                        
                    </div>:
                    ""
                }
                <p>{props.info}</p>
                <p className="product-price"><s>${props.price}</s>${props.discount}</p>
                
                {/* <button onClick={()=>setExpanded(!expanded)} className="btn--flat description--btn">
                    Description <i className="material-icons">{expanded?"expand_less":"expand_more"}</i>
                </button>
                <p style={{maxHeight:`${expanded?"500px":"0px"}`}} className="description">{props.details.description}</p> */}
                {/* {
                    shop.cart?.filter((item)=>item.id===props.id).length>0?
                    <div className="edit-quantity">
                        <button onClick={()=>shop.removeCart(props.id)} className="btn--flat"><i className="material-icons">remove</i></button>
                        <p>{shop.cart.filter((item)=>item.id===props.id)[0].quantity}</p>
                        <button onClick={()=>shop.addCart(props.id, props.discount)} className="btn--flat"><i className="material-icons">add</i></button>
                    </div>:
                    <button onClick={()=>shop.addCart(props.id, props.discount)} className="addCart button">Add to Cart</button>
                } */}
                
            </div>
        </div>
    )
}

export default Product